"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Main = _interopRequireDefault(require("./Main.render"));
var _findMenuItemForUrl = _interopRequireDefault(require("../../../../utils/findMenuItemForUrl"));
const findCurrentMenu = (0, _findMenuItemForUrl.default)(['primary', 'services']);
const MainNavComponent = _ref => {
  let {
    menuItems,
    fetchError,
    reload,
    ModalComp,
    openChangePasswordModal
  } = _ref;
  const [menu, setMenu] = (0, _react.useState)(menuItems);
  (0, _react.useEffect)(() => {
    if (!menuItems) return;
    const url = window.headerConfig && window.headerConfig.activeLink || window.location.href;
    const indexOfCurrentMenuItem = findCurrentMenu(menuItems, url);
    if (indexOfCurrentMenuItem === null) return;
    const [type, index] = indexOfCurrentMenuItem;
    const menuItem = menuItems[type].map((item, i) => {
      if (i === index) {
        return {
          ...item,
          currentSection: true
        };
      }
      return item;
    });
    setMenu({
      ...menuItems,
      [type]: menuItem
    });
  }, [menuItems]);
  return /*#__PURE__*/_react.default.createElement(_Main.default, {
    menuItems: menu,
    fetchError: fetchError,
    reload: reload,
    ModalComp: ModalComp,
    openChangePasswordModal: openChangePasswordModal
  });
};
var _default = exports.default = MainNavComponent;